<template>
  <div id="kt_footer" class="footer bg-white py-4 d-flex flex-lg-column">
    <!--begin::Container-->
    <v-row wrap>
      <v-col align="center" cols="12" md="4">
        <div class="text-dark order-2 order-md-1">
          <span class="text-muted font-weight-bold mr-2"
            >{{ CurrentYear }}©</span
          >
          <a
            href="https://jciindia.in"
            target="_blank"
            class="text-dark-75 text-hover-primary"
            >JCI India</a
          >
        </div>
      </v-col>
      <v-col align="center" cols="12" md="4">
        <span class="text-muted font-weight-bold mr-2">Powered by </span>
        <a
          href="http://vaagai.org.in"
          target="_blank"
          class="text-dark-75 text-hover-primary"
          >Vaagai Tecknowledge</a
        >
      </v-col>
      <v-col align="center" cols="12" md="4">
        App version {{ AppVersion }}
      </v-col>
      <v-col align="center" cols="12" md="12">
        {{ VersionInfo }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { version } from "/package.json";
import common from "@/view/Common.vue";

export default {
  name: "KTFooter",
  mixins: [common],
  data() {
    return {
      AppVersion: version,
      VersionInfo: "",
      CurrentYear: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapGetters(["layoutConfig"]),

    /**
     * Check if subheader width is fluid
     */
    widthFluid() {
      return this.layoutConfig("footer.width") === "fluid";
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    var url2 = "api/pages/version-info";
    var condition2 = {
      UserInterface: 1,
    };
    this.getPageDetails("VersionInfo", "", url2, condition2);
  },
};
</script>
